import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contextualNodeAttributes"];
import { TextSnippetIcon } from 'foundations-assets';
// @ts-expect-error no types
import CanvasToolbarButton from 'rich-text-lib/components/toolbar/ToolbarButton';
// @ts-expect-error no types
import tinymce from 'tinymce';
import { getFetchSnippets } from 'tinymce-data/api/Snippets';
// @ts-expect-error no types
import SnippetPopoverManager from '../components/SnippetPopoverManager';
import { CANVAS_SNIPPET } from '../constants/toolbar';
import { INSERT_SNIPPET, OPEN_SNIPPET_POPOVER } from '../constants/usageTracking';
// @ts-expect-error no types
import withSelectedState from '../hoc/withSelectedState';
import { trackInteraction } from '../utils/usageTracking';
import { i18nWithNameSpace } from '../utils/i18n';
// @ts-expect-error no types
import { insertSnippetContent } from '../hsautocomplete/utils';
// @ts-expect-error no types
import { updateAutocompleteErrorState } from '../data/autocompleteAtoms';
import debounce from 'react-utils/debounce';
import { isUngated } from '../utils/settings';
import { gate } from 'hub-http/gates';
import { jsx as _jsx } from "react/jsx-runtime";
const CanvasToolbarButtonWithSelectedState = withSelectedState(CanvasToolbarButton);
const openChangeKey = 'hsSnippetOpenChange';
const i18nKey = i18nWithNameSpace('TinymcePlugins.hssnippet');
export function addControls(editor, pluginName) {
  const handleClick = () => editor.fire('OpenSnippetPopover');
  const handleMouseEnter = () => editor.fire('PreloadSnippetPicker');
  const handleInsert = snippetBody => {
    editor.insertContent(snippetBody);
    trackInteraction(editor, 'tinymceInsertSnippet', INSERT_SNIPPET);
  };
  const handleOpenChange = isOpen => {
    if (isOpen) {
      trackInteraction(editor, 'tinymceSnippet', OPEN_SNIPPET_POPOVER);
    }
    editor.fire(openChangeKey, {
      selected: isOpen
    });
  };
  tinymce.canvas.addButton(editor, CANVAS_SNIPPET, {
    renderControl: props => {
      const rest = _objectWithoutPropertiesLoose(props, _excluded);
      return /*#__PURE__*/_jsx(CanvasToolbarButtonWithSelectedState, Object.assign({
        "data-test-id": CANVAS_SNIPPET,
        iconName: "textSnippet",
        icon: TextSnippetIcon,
        tooltip: i18nKey('tooltip', {}),
        onClick: handleClick,
        onMouseEnter: handleMouseEnter,
        editor: editor,
        eventKey: openChangeKey
      }, rest));
    }
  });
  tinymce.canvas.addMenuItem(editor, CANVAS_SNIPPET, {
    text: i18nKey('menuItem', {}),
    onClick: handleClick
  });
  const apiClient = editor.getParam('apiClient');
  tinymce.canvas.addPopover(editor, pluginName, {
    renderPopover(renderProps) {
      return /*#__PURE__*/_jsx(SnippetPopoverManager, Object.assign({
        editor: editor,
        onInsert: handleInsert,
        onOpenChange: handleOpenChange,
        fetchSnippets: getFetchSnippets(apiClient)
      }, renderProps));
    }
  });
}
export const TRIGGER = '#';
const SEARCH_RESULTS_LIMIT = 10;
function createSnippetCommand(snippet, index, editor) {
  var _snippet$metadata, _snippet$metadata2;
  const content = ((_snippet$metadata = snippet.metadata) === null || _snippet$metadata === void 0 ? void 0 : _snippet$metadata.htmlBody) || ((_snippet$metadata2 = snippet.metadata) === null || _snippet$metadata2 === void 0 ? void 0 : _snippet$metadata2.body);
  return {
    id: `snippet-${snippet.name}-${index}`,
    label: snippet.name,
    commandFilterPrompt: snippet.shortcut.toLowerCase(),
    onSelect: () => {
      insertSnippetContent(editor, content);
      trackInteraction(editor, 'tinymceInsertSnippet', INSERT_SNIPPET);
    }
  };
}
export function initAutocompletePlugin(editor) {
  if (!isUngated(editor, gate('TinyMCE:SnippetAutocomplete'))) {
    return;
  }
  const apiClient = editor.getParam('apiClient');
  const fetchSnippets = getFetchSnippets(apiClient);
  let currentPromiseResolve = null;
  let lastResults = [];
  const fetchFilteredSnippetsWithErrorHandling = async (query, resolve) => {
    try {
      const snippets = await fetchSnippets({
        query: query.trim(),
        limit: SEARCH_RESULTS_LIMIT,
        offset: 0
      });
      updateAutocompleteErrorState(false);
      lastResults = snippets.results.map((snippet, index) => createSnippetCommand(snippet, index, editor));
    } catch (error) {
      updateAutocompleteErrorState(true);
      lastResults = [];
    }
    resolve(lastResults);
  };
  const debouncedFetchFilteredSnippets = debounce(fetchFilteredSnippetsWithErrorHandling, 200);
  const autocompleteConfig = {
    trigger: TRIGGER,
    getFilteredCommands: (query = '') => {
      // Since debounce returns undefined during timeout
      // track last promise and resolve most recent results to keep from flashing empty
      return new Promise(resolve => {
        if (currentPromiseResolve) {
          currentPromiseResolve(lastResults);
        }
        currentPromiseResolve = resolve;
        debouncedFetchFilteredSnippets(query, resolve);
      });
    }
  };
  tinymce.canvas.addAutocompleteCommand(editor, autocompleteConfig);
}